import React from 'react'
import Box from '@material-ui/core/Box'
import FormSubheader from '../create-profile-form/form-subheader'
import Services from '../form-components/services'
import Skills from '../form-components/skills'
import Tools from '../form-components/tools'
import Price from '../form-components/price'
import { useCreateProfileFieldStyles } from '../create-profile-form/field-styles'

export const SstStep = ({ hideTitle = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()

  const lessonPricing = (
    <Box className={fieldClasses.fieldSection}>
      <FormSubheader
        title="Lesson pricing"
        description="This will not show on your profile."
      />
      <Price />
    </Box>
  )

  if (hideTitle) {
    return (
      <Box className={fieldClasses.sectionStack}>
        {lessonPricing}
        <Services hideHeader />
        <Skills hideHeader />
        <Tools />
      </Box>
    )
  }

  return (
    <Box display="flex" flexDirection="column">
      {lessonPricing}
      <Services />
      <Skills />
      <Tools />
    </Box>
  )
}

export default SstStep
